document.addEventListener('DOMContentLoaded', function() {

  // Cursor
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursorRing');
  if (cursor && ring) {
    document.addEventListener('mousemove', e => {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
      ring.style.left = e.clientX + 'px';
      ring.style.top = e.clientY + 'px';
    });
    document.querySelectorAll('a, button, .product-card, .swatch, .variant-btn').forEach(el => {
      el.addEventListener('mouseenter', () => { cursor.classList.add('hover'); ring.classList.add('hover'); });
      el.addEventListener('mouseleave', () => { cursor.classList.remove('hover'); ring.classList.remove('hover'); });
    });
  }

  // Cart Drawer
  const cartOverlay = document.getElementById('cartOverlay');
  const cartDrawer  = document.getElementById('cartDrawer');
  const cartClose   = document.getElementById('cartClose');
  const cartBtn     = document.getElementById('cartBtn');

  function openCart() {
    if (!cartOverlay || !cartDrawer) return;
    cartOverlay.classList.add('open');
    cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    if (!cartOverlay || !cartDrawer) return;
    cartOverlay.classList.remove('open');
    cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartBtn)     cartBtn.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderCart(cart))
      .catch(err => console.error('Cart error:', err));
  }

  function renderCart(cart) {
    const cartItems  = document.getElementById('cartItems');
    const cartEmpty  = document.getElementById('cartEmpty');
    const cartFooter = document.getElementById('cartFooter');
    const cartTotal  = document.getElementById('cartTotal');
    if (!cartItems) return;

    // Safety check — if cart response is invalid don't wipe the cart
    if (!cart || typeof cart !== 'object') {
      console.error('Invalid cart response');
      return;
    }

    cartItems.innerHTML = '';
    if (cart.item_count === 0) {
      if (cartEmpty)  cartEmpty.style.display  = 'block';
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }
    if (cartEmpty)  cartEmpty.style.display  = 'none';
    if (cartFooter) cartFooter.style.display = 'block';
    if (cartTotal)  cartTotal.textContent    = formatMoney(cart.total_price);
    cart.items.forEach(item => {
      const el = document.createElement('div');
      el.className = 'cart-item';
      const safeKey = item.key;
      el.innerHTML = `
        <img class="cart-item-img" src="${item.image || ''}" alt="${item.title}">
        <div style="flex:1;">
          <div class="cart-item-name">${item.product_title}</div>
          <div class="cart-item-variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="cart-item-controls">
            <button class="qty-btn" data-key="${safeKey}" data-qty="${item.quantity - 1}">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" data-key="${safeKey}" data-qty="${item.quantity + 1}">+</button>
          </div>
        </div>
        <div class="cart-item-price">${formatMoney(item.line_price)}</div>
      `;
      el.querySelectorAll('.qty-btn').forEach(btn => {
        btn.addEventListener('click', function() {
          const key = this.getAttribute('data-key');
          const qty = parseInt(this.getAttribute('data-qty'));
          window.strndUpdateQty(key, qty);
        });
      });
      cartItems.appendChild(el);
    });
  }

  window.strndUpdateQty = function(key, qty) {
    // If qty is 0 or less, confirm before removing item
    if (qty <= 0) {
      if (!confirm('Remove this item from your cart?')) return;
      qty = 0;
    }
    // Disable all qty buttons while updating
    document.querySelectorAll('.qty-btn').forEach(function(btn) {
      btn.disabled = true;
      btn.style.opacity = '0.4';
    });
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => {
      if (!r.ok) throw new Error('Cart update failed');
      return r.json();
    })
    .then(cart => {
      if (cart && cart.items !== undefined) {
        renderCart(cart);
      } else {
        refreshCart();
      }
    })
    .catch(err => {
      console.error('Cart update error:', err);
      // On error, just refresh cart to get real state
      refreshCart();
    });
  };

  window.addToCart = function(variantId, qty) {
    qty = qty || 1;
    const btn = document.getElementById('addToCartBtn');
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
    })
    .then(r => r.json())
    .then(() => {
      if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
      openCart();
    })
    .catch(err => {
      console.error('Add to cart error:', err);
      if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
    });
  };

  function formatMoney(cents) {
    if (!cents || isNaN(cents)) return '$0.00';
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Quick add buttons on collection/home
  document.querySelectorAll('.quick-add-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (variantId) window.addToCart(variantId);
    });
  });

  // ── Product page variant switching ──────────────────────────────
  const variantGroups = document.querySelectorAll('.variant-buttons');
  if (variantGroups.length > 0 && typeof window.productVariants !== 'undefined') {

    function findVariant() {
      return window.productVariants.find(function(v) {
        return v.options.every(function(opt, i) {
          return opt === window.selectedOptions[i];
        });
      });
    }

    function updateProductUI() {
      const variant = findVariant();
      const priceEl     = document.getElementById('price');
      const variantIdEl = document.getElementById('variantId');
      const addBtn      = document.getElementById('addToCartBtn');
      if (!variant) {
        if (priceEl) priceEl.textContent = 'Unavailable';
        if (addBtn)  { addBtn.textContent = 'Unavailable'; addBtn.disabled = true; addBtn.style.opacity = '0.4'; }
        return;
      }
      if (priceEl)     priceEl.textContent = formatMoney(variant.price);
      if (variantIdEl) variantIdEl.value   = variant.id;
      if (addBtn) {
        if (variant.available) {
          addBtn.textContent = 'Add to Cart'; addBtn.disabled = false; addBtn.style.opacity = '1';
        } else {
          addBtn.textContent = 'Sold Out'; addBtn.disabled = true; addBtn.style.opacity = '0.4';
        }
      }
    }

    variantGroups.forEach(function(group) {
      const optionIndex = parseInt(group.dataset.optionIndex);
      group.querySelectorAll('.variant-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          group.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('active'); });
          btn.classList.add('active');
          window.selectedOptions[optionIndex] = btn.dataset.value;
          updateProductUI();
        });
      });
    });

    // Run once on load so price shows correctly for first variant
    updateProductUI();
  }

  // Product page form submit
  const addToCartForm = document.getElementById('addToCartForm');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const variantIdEl = document.getElementById('variantId') || addToCartForm.querySelector('[name="id"]');
      if (variantIdEl && variantIdEl.value) window.addToCart(variantIdEl.value);
    });
  }

  // Scroll reveal
  const reveals = document.querySelectorAll('.reveal');
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.1 });
  reveals.forEach(r => obs.observe(r));

});
